export default "__VITE_ASSET__BhsT7Mrk__"